/**
 * Created by bdunn on 21/10/2014.
 */
module.exports = require("./lib/modelValidator.js");


//////////////////
// WEBPACK FOOTER
// ./~/swagger-model-validator/index.js
// module id = 999
// module chunks = 0